import { render, staticRenderFns } from "./RemoveVoice.vue?vue&type=template&id=7b3890aa&"
import script from "./RemoveVoice.vue?vue&type=script&lang=js&"
export * from "./RemoveVoice.vue?vue&type=script&lang=js&"
import style0 from "./RemoveVoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports